<template>
<b-container fluid>
  <b-card>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group horizontal label="Filtrar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Filtrar por:" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6">
        
        <download-excel v-if="exportExcel" class="pull-right" :data="DataItems" :fields="excelHead" :footer="excelFooter" :name="nameFileExcel">                  
            <b-btn class="pull-right" variant="primary"><i class="fa fa-file-excel-o fa-lg"></i> Exportar Excel </b-btn>
        </download-excel>
      </b-col>
    </b-row>
    <b-table show-empty stacked="md" :items="this.DataItems" :fields="this.DataFields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
      <template slot="action" slot-scope="row">
        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
        <b-button v-if="seen" size="sm" @click.stop="actionButton(row.item.id, 2)" class="mr-1">
          <i class="fa fa-plus"></i>
        </b-button>
        <b-button v-if="seen" size="sm" @click.stop="actionButton(row.item.id, 1)" class="mr-1">
          <i class="fa fa-minus"></i>
        </b-button>
        <!-- <b-button v-if="seen" size="sm" @click.stop="actionButton(row.item.id, 3)" class="mr-1">
          <i class="fa fa-cubes"></i>
        </b-button> -->
        <b-button v-if='btneye' size="sm" @click.stop="infoView(row.item, row.index, $event.target)" class="mr-1">
          <i class="fa fa-eye"></i>
        </b-button>
        <b-button v-if='btndel' size="sm" @click.stop="infoDelete(row.item, row.index, $event.target)" class="mr-1">
          <i class="fa fa-times"></i>
        </b-button>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="this.DataItems.length" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group horizontal label="Registro por página" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>
</b-container>
</template>
<script>
import formDinamic from '@/views/base/form/Form.vue'
export default {
  name: 'tableDinamic',
  components: {
    formDinamic
  },
  props: {
    items: { required: true },
    fields: { required: true },
    methodsTable: { required: true },    
    exportExcel: {type:Boolean, default: true},
    excelHead:{type: Object, default: this.defaultJson},
    excelFooter:{type: String, default:''},
    nameFileExcel: { type:String , default: 'ExcelOut.xls'},
    btndel: { type:Boolean , default: true},
    btneye: { type:Boolean , default: true}
  },
  data () {
    return {
      currentData: {},
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      DataItems: [],
      DataFields: {},
      DataMethodsTable: '',
      seen: false
    }
  },
  computed: {
    sortOptions () {
      return { text: 'Name', value: 'name' }
    }
  },
  mounted () {
    this.DataItems = this.items
    this.DataFields = this.fields
    this.DataMethodsTable = this.methodsTable
    this.validateButton()
  },
  methods: {
    defaultJson(){
      return {'Id': 'id','Nombre': 'name'}
    },
    infoView (item, index, button) {
      let last = window.location.hash.split('/')[(window.location.hash.split('/').length) - 1]
      let origin = window.location.origin
      let url = window.location.hash
      let hash = url.slice(0, (url.length - last.length))
      window.location.href = origin + hash + 'edit/' + item.id
    },
    infoDelete (item, index, button) {
      var retVal = confirm('¿Confirma que deseas eliminar el elemento?')
      if (retVal === true) {
        let id = {id: item.id}
        let json = JSON.stringify(id)
        this.$store.dispatch(this.DataMethodsTable[0], json)
        return true
      } else {
        return false
      }
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    validateButton () {
      console.log(this.DataMethodsTable.length)
      if (this.DataMethodsTable.length === 3) {
        this.seen = true
      }
    },
    actionButton (id, index) {
      let obj = {id: id}
      let json = JSON.stringify(obj)
      this.$store.dispatch(this.DataMethodsTable[index], json)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/table/Table.vue